export default {
  title: 'Sugestii AI',
  subtitle: 'Sugestii de la agentul FoodAmigos pentru restaurantele dvs.',
  empty: 'Nimic de afișat.',
  tabs: {
    pending: 'În așteptare',
    history: 'Istoric',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Tip',
    summary: 'Sugestie',
    created_at: 'Creat',
    status: 'Stare',
    actions: 'Acțiuni',
  },
  statuses: {
    pending: 'În așteptare',
    confirmed: 'Confirmat',
    applied: 'Aplicat',
    rejected: 'Respins',
    failed: 'Eșuat',
    expired: 'Expirat',
  },
  types: {
    'smart_pricing.global_reduce': 'Reducere pe întreg meniul',
    'smart_pricing.category_reduce': 'Reducere pe categorie',
    'competitor_listing.confirm': 'Confirmare listare marketplace',
    'catalog.price_correct': 'Corecție preț',
    'catalog.add_item': 'Adăugare articol lipsă',
    'catalog.quality': 'Calitate conținut',
    'catalog.reorder': 'Reordonare meniu',
  },
  actions: {
    review: 'Revizuire',
    confirm: 'Confirmă',
    reject: 'Respinge',
    cancel: 'Anulează',
    edit: 'Editează',
  },
  edit: {
    label: 'Descrieți modificarea dorită (se generează o nouă revizuire)',
    placeholder: 'Descrieți modificarea dorită',
    placeholders: {
      'smart_pricing.global_reduce': 'ex. setați 15%, redenumiți în „Vară -15%" sau aplicați doar pentru livrare',
      'smart_pricing.category_reduce': 'ex. setați reducerea la Băuturi la 10% și eliminați ridicarea',
      'catalog.price_correct': 'ex. eliminați corecția „Cola" sau setați „Pizza" la €7,50',
      'catalog.add_item': 'ex. eliminați articolul „Apă" sau prețuiți „Falafel Wrap" la €6,50',
      'catalog.quality': 'ex. eliminați articolele „Cartofi prăjiți" și „Cola" din listă',
      'catalog.reorder': 'ex. puneți Băuturile la final și mutați bestseller-ul în fruntea Bowls',
      'competitor_listing.confirm': 'ex. înlocuiți linkul Uber Eats cu https://…, sau adăugați Wolt: https://…',
    },
    submit: 'Generează revizuire',
  },
  revisions: {
    label: 'Revizuire',
    original: 'Original',
    revision_n: 'Revizuirea {{n}}',
  },
  detail: {
    title: 'Detaliu sugestie',
    targets: 'Articole afectate',
    evidence: 'De ce sugerează agentul aceasta',
    no_targets: 'Nicio detaliere a articolelor.',
    composed_from: 'Compus din',
    items_suffix: 'articole',
    nutrition: 'Nutriție',
    uncategorized: 'Necategorizat',
    decided_by: 'Decis de',
    decision_note: 'Notă',
    category_existing: 'existent',
    category_new: 'nou',
    product: 'Produs',
    price_change: 'Modificare preț',
    no_items: 'Niciun articol',
    fills_image: '+ imagine',
    fills_description: '+ descriere',
    fills_nutrition: '+ nutriție',
    fills_modifiers: '+ modificatori',
    competitor_links: 'Linkuri concurență',
    no_competitor_links: 'Niciun link de concurență rezolvat încă.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Respinge această sugestie',
    note_label: 'Motiv',
    note_placeholder: 'Explicați pe scurt de ce respingeți această sugestie',
  },
  toasts: {
    load_failed: 'Încărcarea sugestiilor a eșuat',
    confirmed: 'Sugestie confirmată',
    rejected: 'Sugestie respinsă',
    action_failed: 'Acțiunea nu a putut fi finalizată',
    revision_created: 'Revizuire nouă generată',
    revision_failed: 'Revizuirea nu a putut fi generată din această instrucțiune',
    choose_revision: 'Această sugestie are mai multe revizuiri — deschideți-o și alegeți una pentru confirmare',
  },
};
